/* @flow */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { responsiveStateReducer as browser } from 'redux-responsive';
import { reducer as form } from 'redux-form';

// Import Reducers

import app from './modules/App/AppReducer';
import auth from './modules/Auth/AuthReducer';
import setup from './modules/Setup/SetupReducer';
import analysis from './modules/Analysic/AnalysisReducer';
import performance from './modules/Performance/PerformanceReducer';
import admin from './modules/Admin/AdminReducer';
import nomination from './modules/Nomination/NominationReducer';
import winLossNomination from './modules/Nomination/WinLossReducer';
import pipeline from './modules/Pipeline/PipelineReducer';
import ceNomination from './modules/Nomination/CEReducer';
import forecast from './modules/Forecast/ForecastReducer';
import filter from './modules/Setup/FilterReducer';
import news from './modules/News/NewsReducer';
import searchForm from './components/search-form/search-form-reducer';
import dynamicCell from './components/dynamic-cell/reducer';
import myReps from './modules/MyReps/MyRepsReducer';
import dashboard from './modules/Dashboard/DashboardReducer';
import historyLogs from './components/history-logs/reducer';
import godTables from './components/god-table/reducer';
import customMetas from './components/custom-meta/reducer';
import emailSignatures from './components/request-signature/reducer';
import addOpportunityContact from './components/add-opportunity-contact/reducer';
import requestFeedbackManager from './components/request-feedback-manager/reducer';
import teams from './modules/Team/TeamReducer';


const createReducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    app,
    auth,
    setup,
    analysis,
    performance,
    browser,
    form,
    admin,
    nomination,
    winLossNomination,
    ceNomination,
    forecast,
    filter,
    searchForm,
    news,
    dynamicCell,
    pipeline,
    myReps,
    dashboard,
    historyLogs,
    godTables,
    customMetas,
    emailSignatures,
    addOpportunityContact,
    teams,
    requestFeedbackManager,
  });

export default createReducers;
